"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { IconCopy, IconPencil, IconTrash } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { trackCartItemEditClicked, trackItemDuplicated } from "@/lib/analytics/segment";
import { isFinishedGood } from "@/lib/cart-item-utils";
import { useDuplicateCartItem } from "@/mutations/useDuplicateCartItem";
import { useQuantitiesForItem } from "@/queries/useQuantitiesForItem";
import { useNewCartStore } from "@/stores/useNewCartStore";
import { CartItemError } from "./CartItemError";
interface Props {
  item: CartItemOutputDto;
  onRemoveClick: () => void;
  isUpdatingQuantity: boolean;
}
const DUPLICATE_ERROR_MESSAGE = "We couldn't duplicate this item. Please try again.";
export function CartItemActions(t0) {
  const $ = _c(27);
  const {
    item,
    onRemoveClick,
    isUpdatingQuantity
  } = t0;
  const {
    quantities
  } = useQuantitiesForItem(item);
  const duplicateItem = useDuplicateCartItem(item.id);
  const setIsCartOpen = useNewCartStore(_temp);
  let t1;
  if ($[0] !== item || $[1] !== quantities?.urlSlug || $[2] !== setIsCartOpen) {
    t1 = async function handleEditClick() {
      const response = await fetch(`/api/contentful/product-page-slug?sku=${encodeURIComponent(item.sku.marketingName)}`);
      const data = response.ok ? await response.json() : {
        slug: null
      };
      const resolved = data.slug ?? quantities?.urlSlug;
      if (!resolved) {
        return;
      }
      if (!data.slug) {
        console.warn(`Cart Edit: no Contentful page for sku "${item.sku.marketingName}"; falling back to Product Admin Service urlSlug`);
      }
      const editUrl = new URL(`${window.location.origin}/${resolved}`);
      editUrl.searchParams.set("itemId", item.id);
      const pageUrl = editUrl.toString();
      trackCartItemEditClicked(item, pageUrl);
      setIsCartOpen(false);
      window.location.href = pageUrl;
    };
    $[0] = item;
    $[1] = quantities?.urlSlug;
    $[2] = setIsCartOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleEditClick = t1;
  let t2;
  if ($[4] !== duplicateItem || $[5] !== item) {
    t2 = function handleDuplicateClick() {
      duplicateItem.mutate(item);
      trackItemDuplicated(item);
    };
    $[4] = duplicateItem;
    $[5] = item;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleDuplicateClick = t2;
  let t3;
  if ($[7] !== handleDuplicateClick || $[8] !== handleEditClick || $[9] !== isUpdatingQuantity || $[10] !== item) {
    t3 = !isFinishedGood(item) && <><Button variant="ghost" size="sm" onClick={() => void handleEditClick()} disabled={item.isDuplicate || item.isReorder || isUpdatingQuantity}><IconPencil />Edit</Button><Button variant="ghost" size="sm" onClick={handleDuplicateClick} disabled={item.isDuplicate}><IconCopy />Duplicate</Button></>;
    $[7] = handleDuplicateClick;
    $[8] = handleEditClick;
    $[9] = isUpdatingQuantity;
    $[10] = item;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <div className="flex items-center gap-2">{t3}</div>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconTrash />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== item.id || $[16] !== item.isDuplicate || $[17] !== onRemoveClick) {
    t6 = <Button variant="ghost" size="sm" onClick={onRemoveClick} disabled={item.isDuplicate} data-cart-remove-button={item.id}>{t5}Remove</Button>;
    $[15] = item.id;
    $[16] = item.isDuplicate;
    $[17] = onRemoveClick;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t6) {
    t7 = <div className="flex items-center justify-between px-5 py-2">{t4}{t6}</div>;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const t8 = duplicateItem.isError ? DUPLICATE_ERROR_MESSAGE : undefined;
  let t9;
  if ($[22] !== t8) {
    t9 = <CartItemError message={t8} />;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t9) {
    t10 = <>{t7}{t9}</>;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp(state) {
  return state.setIsCartOpen;
}